import { Component, OnInit } from '@angular/core';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { SessionService } from 'app/sessions/session.service';
import { UserService } from 'app/users/shared/user.service';

@Component({
  selector: 'app-leaves-dashboard',
  templateUrl: './leaves-dashboard.component.html',
  styleUrls: ['./leaves-dashboard.component.scss']
})
export class LeavesDashboardComponent implements OnInit {
  totalLeaves:any;
  lossOfPay:number = 0; 
  constructor(private hrmsService:HRMSService, private ss:SessionService, private userService:UserService) { }

  ngOnInit() {
    this.getUserDesignation();
  }
  getUserDesignation()
  {
    this.userService.getUserDesignation().once("value",(data)=>{
      var designation = data.val(); 
      //console.log("designation",designation);
      this.getTotalLeaves(designation);
    });
  }
  getTotalLeaves(designation)
  {
    this.hrmsService.getAllLeavesOfSpecificDesignation(designation).snapshotChanges().subscribe(data=>{
      this.totalLeaves = [];
      this.totalLeaves[0] = { type : "Casual Leave", count : 0, total: 0 };
      this.totalLeaves[1] = { type : "Sick Leave", count : 0, total: 0 };
        data.forEach(element => {
          if(element.payload.child("type").val() == "Casual Leave")
          {
            var y = element.payload.toJSON();
            y["key"] = element.key;
            this.totalLeaves[0] = y;
            //console.log("this.totalLeaves[0]",this.totalLeaves[0]);
          }
          else if(element.payload.child("type").val() == "Sick Leave")
          {
            var y = element.payload.toJSON();
            y["key"] = element.key;
            this.totalLeaves[1] = y;
          }
      });
      this.getApprovedLeaves();
    });
  }
  getApprovedLeaves()
  {
    this.hrmsService.getApprovedLeaves(this.ss.getUserId).snapshotChanges().subscribe(data=>{
      var cl = 0;
      var sl = 0;
      this.lossOfPay = 0;
      data.forEach(element => {
        var y = element.payload.toJSON();
        //console.log("y",y);
        if(element.payload.child("leaveType").val() == 'Casual Leave' && element.payload.child("status").val() == "Approved")
        {
          cl++;
        }
        else if(element.payload.child("leaveType").val() == 'Sick Leave'  && element.payload.child("status").val() == "Approved")
        {
          sl++;
        }
        else if(element.payload.child("leaveType").val() == 'Loss of Pay'  && element.payload.child("status").val() == "Approved")
        {
          this.lossOfPay++;
        }
      });
      if(this.totalLeaves!=null)
      {
        if(this.totalLeaves[0]!=null)
        this.totalLeaves[0].count = cl;
        if(this.totalLeaves[1]!=null)
        this.totalLeaves[1].count = sl;
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/leaves/leaves-dashboard/leaves-dashboard.component.ts